import React, { useState, useEffect } from "react";
import styled, { css } from "react-emotion";
import * as styles from "../../../newStyles.styles";
import { withRedux } from "helpers";
import { getAdvancedStoreTemplate, getTemplateStoreItems } from "apis";
import { isMobileDevice } from "helpers";
import Product from "./StoreUtil/Product";
import { getStoreItemsForUser } from "../../../../apis";

export const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 10px;
  margin-bottom: 30px;
  @media only screen and (max-width: 767px) {
    padding: 0px;
  }
`;
export const col = css`
  /* flex: 0 0 92%; */
  /* margin: auto 4%; */
  @media only screen and (min-width: 480px) {
    text-align: center;
    flex: 0 0 100%;
  }
  @media only screen and (max-width: 767px) {
    padding: 0px;
    flex: 0 0 100%;
  }
`;

const productCardList = css`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start;
  align-items: stretch;
  list-style: none;
  vertical-align: baseline;
`;
const WebButton = styled("button")`
  padding: 10px;
  width: 190px;
  border-radius: 4px;
  color: white;
  background: ${(props) => props.background};
  font-weight: bold;
  border: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;
const productCard = css`
  /* width: calc(50% - 1.2rem); */
  width: 100%;
  position: relative;
  margin-bottom: 2.4rem;
  padding: 0;
  /* 576px */
  /* @media (min-width: 36em) {
    width: calc(33.33333% - 1.2rem);
    margin-left: 0.6rem;
    margin-right: 0.6rem;
    margin-bottom: 4.8rem;
  } */

  /* 768px */
  @media (min-width: 48em) {
    width: calc(50% - 1.6rem);
    margin-left: 0.8rem;
    margin-right: 0.8rem;
    margin-bottom: 4.8rem;
  }
  /* 960px */
  @media (min-width: 60em) {
    width: calc(33.33333% - 1.2rem);
    padding: 0 1.6rem;
    margin-bottom: 3.2rem;
    margin-left: 0rem;
    margin-right: 1rem;
  }
  /* 1280px */
  @media (min-width: 80em) {
    margin-bottom: 4.8rem;
    padding: 0 1.2rem;
    margin-right: 1rem;
  }
`;

function StoreWebComponent(props) {
  // console.dir(props);
  const [store, setStore] = useState(null);
  const [storeItems, setStoreItems] = useState(null);
  const {
    platformInfo: {
      status: { user },
    },
    isAdmin,
  } = props;
  // console.log("STORE GOT PROPS");
  // console.dir(props);
  // console.log("CART");
  // console.dir(props.cart);

  const getStoreTemplateData = async () => {
    const appId = props.activeApp.id;
    const templateId = props.activeTemplate.id;
    try {
      await getAdvancedStoreTemplate(appId, templateId)
        .then((store) => {
          // console.log("GOT BACK STORE FROM API");
          // console.dir(store);
          setStore(store);
          return store;
        })
        .then((store) => {
          if (!store.allowCustomizedPurchases) {
            getStoreItems(store);
          }
        });
    } catch (e) {
      console.error(e);
    }
  };

  const getStoreItems = async (store) => {
    const appId = props.activeApp.id;

    try {
      const storeItems = await getStoreItemsForUser(
        appId,
        store.templateId,
        user.id
      );
      // console.log("GOT STORE ITEMS FROM STORE: " + store.templateId);
      // console.dir(storeItems);
      setStoreItems(storeItems);
      // console.dir(store);
      props.actions.setWebStore(store.storeSettings, storeItems);
      props.actions.setDeliveryMethod("", 0);
      return storeItems;
    } catch (e) {
      console.error(e);
    }
  };

  const renderStoreItems = () => {
    // console.log("Rendering store items");
    // console.log(storeItems);
    if (!storeItems) return null;
    return (
      <ul className={productCardList}>
        {storeItems.map((item) => {
          return (
            <li className={productCard} key={item.id}>
              <Product
                storeItem={item}
                storeName={props.activeTemplate.pageName}
                storeColor={props.activeApp.view.navigation.navBarColor}
                history={props.history}
                isAdmin={isAdmin}
              ></Product>
            </li>
          );
        })}
      </ul>
    );
  };

  // ComponentDidUpdate
  useEffect(() => {
    if (user) getStoreTemplateData();
  }, [props.activeTemplate, user]);

  // ComponentWillUnMount
  useEffect(() => {
    return () => {
      setStore(null);
      setStoreItems(null);
    };
  }, []);

  if (store && store.allowCustomizedPurchases)
    return (
      <div className={styles.row}>
        <div className={styles.col + " " + styles.col1}>
          {props.activeApp.logo && (
            <img
              src={props.activeApp.logo}
              style={{ width: "200px", margin: "auto", marginTop: "40px" }}
            ></img>
          )}

          <p style={{ width: "300px", margin: "40px auto auto" }}>
            This page is available exclusively on our Mobile360 app. For all our
            offerings, deals, and promotions, click the button below to download
            the Mobile360 app for free!
          </p>
          <a
            href={props.activeApp.deeplinkUrl}
            target="_blank"
            style={{
              textDecoration: "none",
            }}
          >
            <WebButton
              background={props.activeApp.view.navigation.navBarColor}
              style={{ margin: "10px" }}
            >
              Go To App!
            </WebButton>
          </a>
        </div>
      </div>
    );

  return (
    <div className={row}>
      <div className={col + " " + styles.col1}>{renderStoreItems()}</div>
    </div>
  );
}

export default withRedux(StoreWebComponent);
